import { getCharterBySlug } from './charterData';
import CharterDetailTemplate from './CharterDetailTemplate';

const SportfishingPage = () => {
  const data = getCharterBySlug('sportfishing');
  if (!data) return null;
  return <CharterDetailTemplate destination={data} />;
};

export default SportfishingPage;
